import { axiosEjFetch as axiosFetch } from "./axiosEjHelpers";
import type { photoSessionType } from "utils";

export async function postPhotoSession(
  sessionId: string,
  payload: photoSessionType[],
  accessToken: string
) {
  return axiosFetch.patch(`/api/PhotoSession/${sessionId}`, payload, {
    Authorization: `Bearer ${accessToken}`,
  });
}

export async function getPhotoSession(sessionId: string, accessToken: string) {
  return axiosFetch.get(
    `/api/PhotoSession/${sessionId}`,
    {},
    {
      Authorization: `Bearer ${accessToken}`,
    }
  );
}
